// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__q0cz+","faqItem":"FAQ_faqItem__omSuf","faqQuestion":"FAQ_faqQuestion__ufD4U","faqAnswer":"FAQ_faqAnswer__9U0Pc"};